const itemKey = "curOrg"
const curOrg = JSON.parse(localStorage.getItem(itemKey))
const setCurOrg = org => localStorage.setItem(itemKey, JSON.stringify(org))

export { curOrg, setCurOrg }
